import React, { useEffect, useState } from 'react'
// Component
import { CellEclipseBox } from '../../../components/Common/Table'
import {
  TextWrap,
  trimOverlengthString,
} from '../../../components/Common/CellText'
import EditUserGroupModal from './EditUserGroupModal'
// Styled component
import {
  ButtonItem,
  ButtonItemWrapper,
  ListUserGroupWrapper,
  TabUserGroupWrapper,
} from './ListUserGroupStyled'
// Ant design
import {
  Avatar,
  Comment,
  Empty,
  message,
  Popconfirm,
  Tabs,
  Tooltip,
  Input,
  Button,
  Spin,
} from 'antd'
import {
  DeleteTwoTone,
  QuestionCircleOutlined,
  SettingOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from '@ant-design/icons'
// Other
import { inject, observer } from 'mobx-react'
import { apiUrl } from '../../../config'
import TableComponent from '../../../components/Common/TableComponent'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { blue } from '../../../color'
import { ACL_ACTION_TYPE, ASSIGNEE_TYPE } from '../../../constants'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import AccessControlAction from '../../../components/AccessControlAction/AccessControlAction'
import { AppTable } from '../../../components/AppTable/AppTable'
import {
  SettingsOutlineIcon,
  TrashBin2OutlineIcon,
  UserMinusRoundedBrokenIcon,
  UserPlusBrokenIcon,
} from '../../../components/AppIcon'
import UserCard from '../../../components/UserCard/UserCard'
const { TabPane } = Tabs

const ListUserGroup = props => {
  const {
    userGroupStore,
    loadingAnimationStore,
    selectPeopleStore,
    isNhomNhiemVu,
    authenticationStore,
  } = props

  const { dataGroupStoreList, groupActive } = userGroupStore

  const location = useLocation()
  const groupType =
    queryString.parse(location.search, {
      arrayFormat: 'index',
    }).group_type ||
    (location.pathname.includes('mission-management') ? 'nhiem_vu' : undefined)
  const {
    selectUserData,
    assigneePopupType,
    setSelectUserData,
  } = selectPeopleStore

  const [
    isEditUserGroupModalVisible,
    setIsEditUserGroupModalVisible,
  ] = useState(false)
  const [isVisibleSelectPeoplePopup, setIsVisibleSelectPeoplePopup] = useState(
    false
  )
  const [tableLoading, setTableLoading] = useState(false)
  const { Search } = Input
  const queryStringParse = queryString.parse(location.search)

  const handleOpenSelectPeoplePopup = type => {
    selectPeopleStore.setAssigneePopupType(type)
    const convertSelectDataObj =
      groupActive &&
      groupActive.user_list.map(user => {
        return {
          id: user.user_name,
          assignee_type: ASSIGNEE_TYPE.USER,
          full_name: user.name_lowercase,
          image_id: user.image,
          permission: ASSIGNEE_TYPE.user_quan_tri_nhiem_vu,
          department_code: undefined,
          department_name: user.deparment,
        }
      })
    if (convertSelectDataObj) {
      setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: convertSelectDataObj,
      })
    }
    setIsVisibleSelectPeoplePopup(true)
  }
  const handleCancelSelectUser = () => setIsVisibleSelectPeoplePopup(false)

  useEffect(() => {
    ;(async () => {
      if (authenticationStore.currentUser) {
        selectPeopleStore.setAssigneePopupType(
          ASSIGNEE_TYPE.user_quan_tri_nhiem_vu
        )
        getGroupList()
      }
    })()
  }, [authenticationStore.currentUser])

  const handleQuickSearch = async name => {
    userGroupStore.setUserGroupListFilterByName(name)
    getGroupList()
  }

  const getGroupList = async () => {
    try {
      setTableLoading(true)
      const responseGroupList = await userGroupStore.getGroupList(
        groupType,
        authenticationStore.currentCompanyCode()
      )

      if (responseGroupList.length > 0) {
        let newGroup = responseGroupList.find(
          group => group.id_group === groupActive?.id_group
        )
        if (!newGroup) {
          const responseMemberGroup = await userGroupStore.getMemberGroupByIdGroup(
            responseGroupList[0].id_group
          )
          userGroupStore.setGroupActive({
            ...responseGroupList[0],
            user_list: responseMemberGroup.map(user => user.user),
          })
        } else {
          const response = await userGroupStore.getMemberGroupByIdGroup(
            groupActive.id_group
          )
          userGroupStore.setGroupActive({
            ...newGroup,
            user_list: response.map(user => user.user),
          })
        }
      }
    } catch (err) {
      console.log(err)
      message.error('Đã có lỗi xảy ra!')
    } finally {
      setTableLoading(false)
    }
  }

  const tableColumn = [
    {
      title: 'Thông tin',
      width: 250,
      render: record => (
        <span style={{ textTransform: 'capitalize' }}>
          {record.name_lowercase}
        </span>
      ),
    },
    {
      title: 'Email',
      render: record => (
        <Tooltip title={record?.email}>
          <CellEclipseBox>{record?.email}</CellEclipseBox>
        </Tooltip>
      ),
    },
    {
      title: 'Điện thoại',
      render: record => (
        <span>{record.mobileNume ? record?.mobileNume : 'Chưa rõ'}</span>
      ),
    },
    {
      title: 'Địa chỉ',
      render: record => (record.address ? record?.address : 'Chưa rõ'),
    },
    {
      title: 'Chức vụ',
      render: record => (
        <span>{record.job_title ? record?.job_title : 'Chưa rõ'}</span>
      ),
    },
    {
      title: 'Phòng ban',
      render: record => (
        <Tooltip title={record.department_name}>
          <CellEclipseBox>{record.department_name}</CellEclipseBox>
        </Tooltip>
      ),
    },
    {
      title: 'Thao tác',
      fixed: 'right',
      align: 'center',
      width: 140,
      render: record => {
        const isActiveDeleteButton =
          groupActive && groupActive.user_list.length > 1

        return (
          <AccessControlAction
            aclActionType={
              isNhomNhiemVu
                ? ACL_ACTION_TYPE.remove_member__NHOM_NHIEM_VU
                : ACL_ACTION_TYPE.remove_member__NHOM_NGUOI_DUNG
            }>
            <div>
              <Popconfirm
                onConfirm={() =>
                  handleDeleteMemberGroup(
                    record.id_group,
                    record.user_name,
                    record.name_lowercase
                  )
                }
                okText={'Đồng ý'}
                cancelText={'Không'}
                okType={'danger'}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                title={'Bạn có muốn xóa người dùng này?'}>
                <Button
                  title={
                    isActiveDeleteButton
                      ? 'Xóa người dùng khỏi nhóm'
                      : 'Phải có ít nhất một người trong nhóm!'
                  }
                  disabled={!isActiveDeleteButton}
                  icon={
                    <UserMinusRoundedBrokenIcon
                      style={{ color: 'red', width: 18, height: 18 }}
                    />
                  }
                  shape="circle"
                  type="text"
                />
              </Popconfirm>
            </div>
          </AccessControlAction>
        )
      },
    },
  ]

  const handleDeleteMemberGroup = async (id_group, username, user_name) => {
    const dataSubmit = {
      user_names: [username],
    }
    setTableLoading(true)
    try {
      await userGroupStore.deleteMemberGroup(id_group, dataSubmit)
      getGroupList()
      message.success(
        <span>
          Xóa người dùng <b>{user_name}</b> thành công!
        </span>
      )
    } catch (err) {
      message.error('Đã có lỗi xảy ra')
      console.log(err)
    } finally {
      setTableLoading(false)
    }
  }

  const handleDeleteGroup = async () => {
    setTableLoading(true)
    try {
      await userGroupStore.deleteGroup(groupActive.id_group)
      getGroupList()

      message.success(
        <span>
          Xóa nhóm <b>{groupActive.name_group}</b> thành công!
        </span>
      )
    } catch (err) {
      console.log(err)
      // các đầu api trên k return response error
      message.error('Đã có lỗi xảy ra')
    } finally {
      setTableLoading(false)
    }
  }

  const onChangeTabUserGroup = async key => {
    const groupTarget = dataGroupStoreList.find(
      group => group.id_group === parseInt(key)
    )
    if (groupTarget?.user_list.length > 0) {
      return userGroupStore.setGroupActive(groupTarget)
    }
    setTableLoading(true)
    try {
      const response = await userGroupStore.getMemberGroupByIdGroup(
        parseInt(key)
      )
      let groupActive = dataGroupStoreList.find(
        group => group?.id_group === response[0]?.group_id
      )
      if (!groupActive) {
        groupActive = {
          id_group: groupTarget.id_group,
          name_group: groupTarget.name_group,
          user_list: [],
        }
      }

      userGroupStore.setGroupActive({
        ...groupActive,
        user_list: response.map(user => user.user),
      })
    } catch (err) {
      console.log(err)
      message.error('Lấy thông tin người dùng trong nhóm thất bại!')
    } finally {
      setTableLoading(false)
    }
  }

  const handleSubmitSelectUser = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      const responseGroupListFetchNameGroup = await userGroupStore.getGroupList(
        groupType,
        authenticationStore.currentCompanyCode()
      )
      const nameGroup = responseGroupListFetchNameGroup.find(
        group => group.id_group === groupActive.id_group
      ).name_group
      const usersSubmit = {
        name: nameGroup,
        group_member_list: selectUserData[
          ASSIGNEE_TYPE.user_quan_tri_nhiem_vu
        ].map(user => user.id),
      }
      await userGroupStore.updateGroup(groupActive.id_group, usersSubmit)
      const responseGroupList = await userGroupStore.getGroupList(
        groupType,
        authenticationStore.currentCompanyCode()
      )
      const response = await userGroupStore.getMemberGroupByIdGroup(
        groupActive.id_group
      )
      userGroupStore.setGroupActive({
        ...responseGroupList.find(
          group => group.id_group === groupActive.id_group
        ),
        user_list: response.map(user => user.user),
      })
      message.success('Cập nhật nhóm thành công!')
    } catch (err) {
      console.log(err)
      message.error('Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
    setIsVisibleSelectPeoplePopup(false)
  }

  const handleCloseEditUserGroupModal = async () => {
    getGroupList()
    setIsEditUserGroupModalVisible(false)
  }

  return (
    <ListUserGroupWrapper>
      <Search
        style={{ width: 270, marginBottom: 16 }}
        className="custom-search-input"
        allowClear
        onSearch={value => handleQuickSearch(value)}
        defaultValue={queryStringParse.name}
        placeholder={'Tìm kiếm theo tên nhóm'}
      />
      <TabUserGroupWrapper
        className="custom-ant-vertical-tabs "
        tabPosition={'left'}
        onChange={onChangeTabUserGroup}
        activeKey={groupActive?.id_group + ''}>
        {dataGroupStoreList.map(group => {
          const userListHasIdGroup =
            group.id_group === groupActive?.id_group
              ? groupActive.user_list?.map(user => {
                  return {
                    ...user,
                    id_group: group.id_group,
                  }
                })
              : []

          return (
            <TabPane
              tab={
                <>
                  <TextWrap>
                    {trimOverlengthString(group.name_group, 230)}
                  </TextWrap>
                </>
              }
              key={group.id_group}>
              <div className="group-name-header">
                <h3>{group.name_group}</h3>

                <ButtonItemWrapper>
                  <AccessControlAction
                    aclActionType={
                      isNhomNhiemVu
                        ? ACL_ACTION_TYPE.edit__NHOM_NHIEM_VU
                        : ACL_ACTION_TYPE.edit__NHOM_NGUOI_DUNG
                    }>
                    <Button
                      shape="circle"
                      type="text"
                      title="Thêm người từ phòng ban"
                      onClick={() =>
                        handleOpenSelectPeoplePopup(
                          ASSIGNEE_TYPE.user_quan_tri_nhiem_vu
                        )
                      }
                      icon={
                        <UserPlusBrokenIcon
                          style={{ color: blue, width: 18, height: 18 }}
                        />
                      }
                    />

                    <Button
                      shape="circle"
                      type="text"
                      title="Chỉnh sửa người trong nhóm"
                      onClick={() => setIsEditUserGroupModalVisible(true)}
                      icon={
                        <SettingsOutlineIcon
                          style={{ color: '#40A9FF', width: 18, height: 18 }}
                        />
                      }
                    />
                  </AccessControlAction>
                  <AccessControlAction
                    aclActionType={
                      isNhomNhiemVu
                        ? ACL_ACTION_TYPE.delete__NHOM_NHIEM_VU
                        : ACL_ACTION_TYPE.delete__NHOM_NGUOI_DUNG
                    }>
                    <Popconfirm
                      onConfirm={() => handleDeleteGroup()}
                      okText={'Đồng ý'}
                      cancelText={'Không'}
                      okType={'danger'}
                      icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                      title={'Bạn có muốn xóa nhóm này không?'}>
                      <Button
                        shape="circle"
                        danger
                        type="text"
                        title="Xóa nhóm"
                        onClick={event => event.stopPropagation()}
                        icon={
                          <TrashBin2OutlineIcon
                            style={{ color: 'red', width: 18, height: 18 }}
                          />
                        }
                      />
                    </Popconfirm>
                  </AccessControlAction>
                </ButtonItemWrapper>
              </div>

              <Spin spinning={loadingAnimationStore.tableLoading}>
                {userListHasIdGroup?.length ? (
                  <>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                        columnGap: 16,
                        rowGap: 24,
                      }}>
                      {userListHasIdGroup.map(user => {
                        const isActiveDeleteButton =
                          groupActive && groupActive.user_list.length > 1
                        return (
                          <UserCard
                            key={user?.user_name + group.id_group}
                            name={user?.name_lowercase}
                            role={user?.job_title}
                            email={user?.email}
                            phone={user?.phone}
                            avatar={
                              user?.image
                                ? `${apiUrl}/api/v1/images/${user.image}`
                                : null
                            }
                            addon={
                              <AccessControlAction
                                aclActionType={
                                  isNhomNhiemVu
                                    ? ACL_ACTION_TYPE.remove_member__NHOM_NHIEM_VU
                                    : ACL_ACTION_TYPE.remove_member__NHOM_NGUOI_DUNG
                                }>
                                <div>
                                  <Popconfirm
                                    onConfirm={() =>
                                      handleDeleteMemberGroup(
                                        user.id_group,
                                        user.user_name,
                                        user.name_lowercase
                                      )
                                    }
                                    okText={'Đồng ý'}
                                    cancelText={'Không'}
                                    okType={'danger'}
                                    icon={
                                      <QuestionCircleOutlined
                                        style={{ color: 'red' }}
                                      />
                                    }
                                    title={'Bạn có muốn xóa người dùng này?'}>
                                    <Button
                                      title={
                                        isActiveDeleteButton
                                          ? 'Xóa người dùng khỏi nhóm'
                                          : 'Phải có ít nhất một người trong nhóm!'
                                      }
                                      disabled={!isActiveDeleteButton}
                                      icon={
                                        <UserMinusRoundedBrokenIcon
                                          style={{
                                            color: 'red',
                                            width: 18,
                                            height: 18,
                                          }}
                                        />
                                      }
                                      shape="circle"
                                      type="text"
                                    />
                                  </Popconfirm>
                                </div>
                              </AccessControlAction>
                            }
                          />
                        )
                      })}
                    </div>
                  </>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Không có người dùng"
                  />
                )}
              </Spin>
              {/* <AppTable
                rowKey={record => {
                  return record.user_name + group.id_group
                }}
                columns={tableColumn}
                dataSource={userListHasIdGroup}
                pagination={userListHasIdGroup.length > 10}
                loading={tableLoading}
              /> */}
            </TabPane>
          )
        })}
      </TabUserGroupWrapper>
      {!dataGroupStoreList.length ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={'Không có nhóm nào!'}
        />
      ) : null}
      <EditUserGroupModal
        isEditUserGroupModalVisible={isEditUserGroupModalVisible}
        handleCloseEditUserGroupModal={handleCloseEditUserGroupModal}
      />
      <SelectPeoplePopup
        disableSelectDepartment
        handleCancelSelectUser={handleCancelSelectUser}
        handleSubmitSelectUser={handleSubmitSelectUser}
        isVisibleSelectPeoplePopup={isVisibleSelectPeoplePopup}
      />
    </ListUserGroupWrapper>
  )
}

ListUserGroup.propTypes = {}

export default inject(
  'userGroupStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'authenticationStore'
)(observer(ListUserGroup))
